import tribunalAPI from "../../api/tribunalAPi";
import { BodySolicitudDemanda } from "interfaces/demandas/demandasInterface";
import {
  BodyRegistrarPromocion,
  BodySolicitudPromocion,
  BodySolicitudPromocionLaboral,
  InstanciasOrdinariasResponse,
  JuzgadosOrdinariosResponse,
  MateriasOrdinariasResponse,
  ParamsPromociones,
  RegistrarPromocionResponse,
  ResponseGetSolicitudPromocion,
  ResponsePromocionesFamCivMer,
  ResponsePromocionesLaboral,
  ResponsePromocionesPenal,
  ResponsePromocionLaboralFiles,
  ResponseSolicitudPromocion,
  ResponseUpdateSolicitudPromocion,
  ResponseUploadFile,
} from "interfaces/promociones/promocionesInterface";

const getSolicitudPromocionById = async (id: number) => {
  let url = `/promociones/solicitud/${id}`;
  return await tribunalAPI.get<ResponseGetSolicitudPromocion>(url);
};

const getSolicitudesPromocion = async (body: BodySolicitudDemanda) => {
  let url = "/promociones/obtener/solicitud-promociones";
  return await tribunalAPI.get<ResponsePromocionesFamCivMer>(url, {
    params: {
      page: body?.page,
      perPage: body?.perPage,
      querySearch: body.querySearch,
      estatus: body.estatus,
    },
  });
};

const getSolicitudesPromocionPenal = async (body: BodySolicitudDemanda) => {
  let url = "/promociones/obtener/solicitud-promociones-penales";
  return await tribunalAPI.get<ResponsePromocionesPenal>(url, {
    params: { page: body?.page, perPage: body?.perPage, fromSigepea: body.fromSigepea ?? false },
  });
};

const getSolicitudesPromocionLaboral = async (body: BodySolicitudDemanda) => {
  let url = "/promociones/obtener/solicitud-promociones-laborales";
  return await tribunalAPI.get<ResponsePromocionesLaboral>(url, {
    params: { page: body?.page, perPage: body?.perPage },
  });
};

/** nueva promocion - contestacion de la demanda */

const getMateriasOridinariasEnLinea = async (params: ParamsPromociones) => {
  let url = "/promociones/obtener/materias-ordinarias-en-linea";
  return await tribunalAPI.get<MateriasOrdinariasResponse>(url, {
    params,
  });
};

const getJuzgadosOrdinariasEnLinea = async (params: ParamsPromociones) => {
  let url = "/promociones/obtener/juzgados-ordinarias-en-linea";
  return await tribunalAPI.get<JuzgadosOrdinariosResponse>(url, {
    params,
  });
};

const getInstanciasOrdinariasEnLinea = async (params: ParamsPromociones) => {
  let url = "/promociones/obtener/instancias-ordinarias-en-linea";
  return await tribunalAPI.get<InstanciasOrdinariasResponse>(url, {
    params,
  });
};

const postSaveSolicitudPromocion = async (body: BodySolicitudPromocion) => {
  let url = "/promociones/solicitud";
  return await tribunalAPI.post<ResponseSolicitudPromocion>(url, body);
};

const putUpdateSolicitudPromocion = async (body: BodySolicitudPromocion) => {
  let url = "/promociones/solicitud";
  return await tribunalAPI.put<ResponseUpdateSolicitudPromocion>(url, body);
};

const postUploadFilePromocion = async <T>(body: T) => {
  let url = "/promociones/solicitud/documentos";
  return await tribunalAPI.post<ResponseUploadFile>(url, body);
};

const getFileSolicitudPromocion = async (params: string) => {
  let url = "/promociones/solicitud/documentos";
  return tribunalAPI.get(url, {
    params,
    responseType: "arraybuffer",
  });
};

const deleteFileSolicitudPromocion = async (params: { path: string }) => {
  let url = "/promociones/solicitud/documentos";
  return await tribunalAPI.delete(url, {
    params,
  });
};

const postRegistrarPromocion = async (body: BodyRegistrarPromocion) => {
  let url = "/promociones/registrar";
  return await tribunalAPI.post<RegistrarPromocionResponse>(url, body);
};

const deleteSolcitudPromocion = async (idSolicitudActuacion: number) => {
  let url = `/promociones/solicitud/${idSolicitudActuacion}`;
  return await tribunalAPI.delete(url);
};

const getSolicitudPromocionLaboral = async ({
  idDocumento,
  tipo,
  cveTipoDoc,
}: BodySolicitudPromocionLaboral) => {
  let url = `/actuaciones-pdf/obtener/promociones-laboral/${idDocumento}/${tipo}/${cveTipoDoc}`;
  return await tribunalAPI.get<ResponsePromocionLaboralFiles>(url);
};

const getAcusePromocion = async (idActuacion: number) => {
  let url = `/promociones/${idActuacion}/acuse`;
  return await tribunalAPI.get(url, {
    responseType: "arraybuffer",
  });
};

export {
  getMateriasOridinariasEnLinea,
  getJuzgadosOrdinariasEnLinea,
  getSolicitudesPromocion,
  getSolicitudesPromocionPenal,
  getSolicitudesPromocionLaboral,
  getFileSolicitudPromocion,
  getInstanciasOrdinariasEnLinea,
  postSaveSolicitudPromocion,
  putUpdateSolicitudPromocion,
  postUploadFilePromocion,
  deleteFileSolicitudPromocion,
  postRegistrarPromocion,
  getSolicitudPromocionById,
  deleteSolcitudPromocion,
  getSolicitudPromocionLaboral,
  getAcusePromocion,
};
